<bizz-icon iconName="circle" transform="down-2" kendoTooltip
[title]="statusText ? (statusText | translate) : ''" class="type-{{statusType}} h-{{ size/4 }} w-{{ size/4 }}"></bizz-icon>